var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8BC34A;}\n\t.st1{fill:#C5CAE9;}\n\t.st2{fill:#689F38;}\n\t.st3{fill:#9FA8DA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,18.8h12.5c2.9,0,5.3-2.3,5.3-5.3l0,0c0-2.9-2.3-5.3-5.3-5.3H5.3C2.4,8.2,0,10.6,0,13.5l0,0 C0,16.4,2.3,18.8,5.3,18.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,7.8c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8S20.4,7.8,17.2,7.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.5,13.5c0-2.3,1.4-4.4,3.4-5.3h-3.3c-1.3,1.4-2.1,3.2-2.1,5.3s0.8,3.9,2.1,5.3h3.3 C12.9,17.9,11.5,15.8,11.5,13.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.2,18.3c2.6,0,4.8-2.2,4.8-4.8c0-0.6-0.1-1.1-0.3-1.6l-4.5,1.6l-2.2,4.3C15.8,18.1,16.5,18.3,17.2,18.3z  M17.2,8.7c-2.6,0-4.8,2.2-4.8,4.8c0,0.6,0.1,1.1,0.3,1.6l4.5-1.6l2.2-4.3C18.7,8.9,18,8.7,17.2,8.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,41.8h12.5c2.9,0,5.3-2.3,5.3-5.3l0,0c0-2.9-2.3-5.3-5.3-5.3H5.3c-2.9,0-5.3,2.3-5.3,5.3l0,0 C0,39.4,2.3,41.8,5.3,41.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,30.8c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8S20.4,30.8,17.2,30.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.5,36.5c0-2.3,1.4-4.4,3.4-5.3h-3.3c-1.3,1.4-2.1,3.2-2.1,5.3s0.8,3.9,2.1,5.3h3.3 C12.9,40.9,11.5,38.8,11.5,36.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.2,41.3c2.6,0,4.8-2.2,4.8-4.8c0-0.6-0.1-1.1-0.3-1.6l-4.5,1.6l-2.2,4.3C15.8,41.1,16.5,41.3,17.2,41.3z  M17.2,31.7c-2.6,0-4.8,2.2-4.8,4.8c0,0.6,0.1,1.1,0.3,1.6l4.5-1.6l2.2-4.3C18.7,31.9,18,31.7,17.2,31.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,18.8h12.5c2.9,0,5.3-2.3,5.3-5.3l0,0c0-2.9-2.3-5.3-5.3-5.3H32.3c-2.9,0-5.3,2.3-5.3,5.3l0,0 C27,16.4,29.3,18.8,32.3,18.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,7.8c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8S47.4,7.8,44.2,7.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.5,13.5c0-2.3,1.4-4.4,3.4-5.3h-3.3c-1.3,1.4-2.1,3.2-2.1,5.3s0.8,3.9,2.1,5.3h3.3 C39.9,17.9,38.5,15.8,38.5,13.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.2,18.3c2.6,0,4.8-2.2,4.8-4.8c0-0.6-0.1-1.1-0.3-1.6l-4.5,1.6l-2.2,4.3C42.8,18.1,43.5,18.3,44.2,18.3z  M44.2,8.7c-2.6,0-4.8,2.2-4.8,4.8c0,0.6,0.1,1.1,0.3,1.6l4.5-1.6l2.2-4.3C45.7,8.9,45,8.7,44.2,8.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,41.8h12.5c2.9,0,5.3-2.3,5.3-5.3l0,0c0-2.9-2.3-5.3-5.3-5.3H32.3c-2.9,0-5.3,2.3-5.3,5.3l0,0 C27,39.4,29.3,41.8,32.3,41.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,30.8c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8S47.4,30.8,44.2,30.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.5,36.5c0-2.3,1.4-4.4,3.4-5.3h-3.3c-1.3,1.4-2.1,3.2-2.1,5.3s0.8,3.9,2.1,5.3h3.3 C39.9,40.9,38.5,38.8,38.5,36.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.2,41.3c2.6,0,4.8-2.2,4.8-4.8c0-0.6-0.1-1.1-0.3-1.6l-4.5,1.6l-2.2,4.3C42.8,41.1,43.5,41.3,44.2,41.3z  M44.2,31.7c-2.6,0-4.8,2.2-4.8,4.8c0,0.6,0.1,1.1,0.3,1.6l4.5-1.6l2.2-4.3C45.7,31.9,45,31.7,44.2,31.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchGroup);
export default __webpack_public_path__ + "static/media/switchGroup.726bf0b1a507bff7fb1cabf2aef4c1a1.svg";
export { ForwardRef as ReactComponent };